import { withColorFields } from "../sectionKit";

/**
 * Every homepage section, found automatically: each folder in this directory
 * whose name is a section type and holds a definition.js. Add a section by
 * adding a folder; nothing else needs editing. `order` sets its place in the
 * editor's library.
 */
const context = require.context("./", true, /^\.\/[a-z0-9_]+\/definition\.js$/);

export const SECTION_DEFINITIONS = context
  .keys()
  .map((key) => {
    const definition = context(key).default;
    const folder = key.split("/")[1];
    if (definition.type !== folder) {
      throw new Error(`Section folder "${folder}" must match its type "${definition.type}".`);
    }
    return withColorFields(definition);
  })
  .sort((a, b) => (a.order || 999) - (b.order || 999));
